import { render, staticRenderFns } from "./PopupClientConfig.vue?vue&type=template&id=979251ba"
import script from "./PopupClientConfig.vue?vue&type=script&lang=js"
export * from "./PopupClientConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('979251ba')) {
      api.createRecord('979251ba', component.options)
    } else {
      api.reload('979251ba', component.options)
    }
    module.hot.accept("./PopupClientConfig.vue?vue&type=template&id=979251ba", function () {
      api.rerender('979251ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Account/PopUps/PopupClientConfig.vue"
export default component.exports